export type SeekingValue = 'woman' | 'man' | 'all';

export type SearchableCity = {
  id: string;
  nameRu: string;
  region: string;
};

export function initialSeekingValue(
  gender: string | null | undefined,
  persisted: readonly string[] | null | undefined,
): SeekingValue {
  if (persisted?.length) {
    if (persisted.includes('woman') && persisted.includes('man')) return 'all';
    if (persisted[0] === 'man' || persisted[0] === 'woman') return persisted[0];
  }
  if (gender === 'man') return 'woman';
  if (gender === 'woman') return 'man';
  return 'all';
}

const normalizeCitySearch = (value: string) =>
  value.trim().toLocaleLowerCase('ru-RU').replace(/ё/gu, 'е');

export function searchCityOptions<T extends SearchableCity>(
  cities: readonly T[],
  query: string,
  limit = 8,
): T[] {
  const needle = normalizeCitySearch(query);
  if (!needle) return [];

  return cities
    .map((city, index) => {
      const name = normalizeCitySearch(city.nameRu);
      const rank = name.startsWith(needle) ? 0 : name.includes(needle) ? 1 : -1;
      return { city, index, rank };
    })
    .filter((entry) => entry.rank >= 0)
    .sort(
      (left, right) =>
        left.rank - right.rank ||
        left.city.nameRu.localeCompare(right.city.nameRu, 'ru-RU') ||
        left.city.region.localeCompare(right.city.region, 'ru-RU') ||
        left.index - right.index,
    )
    .slice(0, limit)
    .map(({ city }) => city);
}
